module.exports = __webpack_public_path__ + "img/08.29119cd7.jpg";